import { render, staticRenderFns } from "./StockLevels.vue?vue&type=template&id=753dfad2&scoped=true"
import script from "./StockLevels.vue?vue&type=script&lang=js"
export * from "./StockLevels.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "753dfad2",
  null
  
)

export default component.exports